import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../dialog";
import { Button } from "../button";

function AppDialog({
  open,
  onOpenChange,
  title,
  description,
  size = "default",
  children,
  footer,
  onConfirm,
  confirmLabel = "ذخیره",
  cancelLabel = "انصراف",
  confirmVariant = "success",
  loading = false,
  showFooter = true,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size={size} aria-describedby={description ? undefined : undefined}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        {description && (
          <p className="text-sm text-muted-foreground">{description}</p>
        )}
        {children}
        {showFooter && (
          <DialogFooter>
            {footer ?? (
              <>
                <Button
                  type="button"
                  variant="secondary"
                  onClick={() => onOpenChange?.(false)}
                >
                  {cancelLabel}
                </Button>
                {onConfirm && (
                  <Button
                    type="button"
                    variant={confirmVariant}
                    disabled={loading}
                    onClick={onConfirm}
                  >
                    {loading ? "در حال ذخیره..." : confirmLabel}
                  </Button>
                )}
              </>
            )}
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
}

export { AppDialog };
